module.exports = __webpack_public_path__ + "img/icon-flag-active.b170d6b6.svg";